import { tramo } from '../core/componentes.js';
import { nivel } from '../core/dominio.js';
import { S } from '../core/estado.js';
import { fecha } from '../core/formato.js';

/* =====================================================================
   GesCon · prototipo v2
   ---------------------------------------------------------------------
   CAPA DE DATOS. En producción cada colección es una tabla de Postgres
   en Supabase con esta misma forma:
     contratos · anualidades · precios · imputaciones · certificaciones
     pedidos · pedido_lineas · documentos · usuarios · usuario_contrato
   ===================================================================== */

export const HOY = new Date();

export const db = {
  /* Tipos impositivos por defecto: se aplican a los contratos nuevos y se
     pueden cambiar desde Ajustes sin tocar código si cambia la normativa. */
  ajustes: {iva:21, beneficioIndustrial:6, gastosGenerales:13},

  /* El login ya va contra Supabase Auth (ver src/data/supabase.js); estas
     colecciones siguen siendo la caché en memoria que pinta la interfaz.
     Falta el siguiente paso: leerlas y escribirlas contra la base de datos
     real en vez de solo aquí, así que de momento se vacían al recargar. */
  usuarios: [],
  contratos: [],
  precios: [],
  imputaciones: [],
  certificaciones: [],
  pedidos: [],
  zonas: [],
  carreteras: [],
  almacenes: [],
  contactos: [],
  documentos: [],
};

export const TIPOS_DOC = ['Pedido','Albarán','Parte de trabajo','Foto','Factura','Pliego','Acta','Certificado','Otro'];
export const ESTADOS_PEDIDO = ['solicitado','confirmado','parcial','servido','anulado'];

export const ROLES = {admin:'Administrador', operario:'Enc. General', encargado:'Encargado', consulta:'Consulta'};
export const ROL_DESC = {
  admin:     'Da de alta contratos, valida imputaciones, emite certificaciones y ve todos los informes.',
  operario:  'Pide material, registra el trabajo ejecutado e imputa al contrato. Sigue de cerca cómo va el gasto.',
  encargado: 'Recibe los pedidos en obra: adjunta el albarán, anota lo recibido y marca el pedido como servido. No pide ni imputa.',
  consulta:  'Lectura de contratos, certificaciones e informes. No modifica nada.',
};
